<div class="modal-header pb-2">
  <h4 class="modal-title">{{ activeTab == 'embedCode' ? 'Embed Public Stories' : 'Embed Options'}}</h4>
  <button type="button" (click)="close()" class="close">
    <span aria-hidden="true">
      <svg role="img">
        <use xlink:href="#icon-close"></use>
      </svg></span>
  </button>
</div>
<div class="modal-body">

  <ul role="tablist" class="nav nav-tabs tabs-icon mb-4">
    <li class="nav-item" [style.backgroundColor]="activeTab == 'iframe' ? navigation_color : ''"  [style.color]="activeTab == 'iframe' ? '#fff' : '#78909c'">
      <a href="javascript:void(0)" [style.border-color]="activeTab == 'iframe' ? navigation_color : ''" (click)="activateTab('iframe')" [style.color]="activeTab == 'iframe' ? '#fff' : '#78909c'" role="tab" class="nav-link"
       >
        <span class="text">Feed iFrame</span></a>
    </li>
    <li class="nav-item" [style.backgroundColor]="activeTab == 'embedCode' ? navigation_color : ''" [style.color]="activeTab == 'embedCode' ? '#fff' : '#78909c'">
      <a href="javascript:void(0)" [style.border-color]="activeTab == 'embedCode' ? navigation_color : ''" (click)="activateTab('embedCode')" [style.color]="activeTab == 'embedCode' ? '#fff' : '#78909c'" role="tab" class="nav-link"
        >
        <span class="text">Feed Script</span></a>
    </li>

    <li class="nav-item" [style.backgroundColor]="activeTab == 'RSS' ? navigation_color : ''" [style.color]="activeTab == 'RSS' ? '#fff' : '#78909c'">
      <a href="javascript:void(0)" [style.border-color]="activeTab == 'RSS' ? navigation_color : ''" (click)="activateTab('RSS')" [style.color]="activeTab == 'RSS' ? '#fff' : '#78909c'" role="tab" class="nav-link"
>
        <span class="text">Feed RSS</span></a>
    </li>
    <li class="nav-item"  [style.backgroundColor]="activeTab == 'embedButton' ? navigation_color : ''" [style.color]="activeTab == 'embedButton' ? '#fff' : '#78909c'"*ngIf="initialState.sendData?.from == 'company' || initialState.sendData?.from == 'campaign'">
      <a href="javascript:void(0)" [style.border-color]="activeTab == 'embedButton' ? navigation_color : ''" (click)="activateTab('embedButton')" [style.color]="activeTab == 'embedButton' ? '#fff' : '#78909c'" role="tab" class="nav-link"
        >
        <span class="text">Submit Story Button</span></a>
    </li>

    <li class="nav-item" [style.backgroundColor]="activeTab == 'dataUrl' ? navigation_color : ''" [style.color]="activeTab == 'dataUrl' ? '#fff' : '#78909c'">
      <a href="javascript:void(0)" [style.border-color]="activeTab == 'dataUrl' ? navigation_color : ''" (click)="activateTab('dataUrl')" [style.color]="activeTab == 'dataUrl' ? '#fff' : '#78909c'" role="tab" class="nav-link">
        <span class="text">Data URL</span>
      </a>
    </li>
  </ul>

  <div class="embed_tab" [formGroup]="embedForm" *ngIf="activeTab == 'embedCode'">
    <div class="option-wrapper embed-sub-wrapper mb-2 p-3" *ngIf="!IsScriptCreated">
      <h6>Display Story Elements</h6>
      <div class="row mt-3">
        <div class="col-md-2">
          <div>
            <label class="switch mr-1">
              <input type="checkbox" formControlName="isTitle"><span class="slider"></span>
            </label>
            <div class="w-50-p d-inline-block">
              Title
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div>
            <label class="switch mr-1">
              <input type="checkbox" formControlName="isAuthor"><span class="slider"></span>
            </label>
            <div class="w-50-p d-inline-block">
              Author
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div>
            <label class="switch mr-1">
              <input type="checkbox" formControlName="isDate"><span class="slider"></span>
            </label>
            <div class="w-50-p d-inline-block">
              Date
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div>
            <label class="switch mr-1">
              <input type="checkbox" formControlName="isTags"><span class="slider"></span>
            </label>
            <div class="w-50-p d-inline-block">
              Tags
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div>
            <label class="switch mr-1">
              <input type="checkbox" formControlName="isCta"><span class="slider"></span>
            </label>
            <div class="w-50-p d-inline-block">
              CTA
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-accordion [multi]="false" *ngIf="!IsScriptCreated">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <span>Embed Feed Colors And Fonts</span></mat-panel-title>
        </mat-expansion-panel-header>
        <div class="color-wrapper embed-sub-wrapper" *ngIf="!IsScriptCreated">
          <!-- <h6>Embed Colors</h6> -->
          <div class="row mb-1 pl-7px">
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="backgroundColor" [formControl]="embedForm.controls.backgroundColor"
                label="Background" name="Background" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="foregroundColor" [formControl]="embedForm.controls.foregroundColor"
                label="Hover" name="Hover Background" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="highlightColor" [formControl]="embedForm.controls.highlightColor"
                label="Button Hover" name="Button Hover" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="border_color" [formControl]="embedForm.controls.border_color"
                label="Border" name="Border" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="user_labels" [formControl]="embedForm.controls.user_labels"
                label="User Label" name="Border" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="guest_label" [formControl]="embedForm.controls.guest_label"
                label="Guest Label" name="Guestlabel" type="text"></gs-input-color-picker>
            </div>
            <!-- <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="cta_button_background" [formControl]="embedForm.controls.cta_button_background"
                label="CTA Button" name="CTA Button" type="text"></gs-input-color-picker>
            </div> -->
          </div>  
          <div class="row mb-2 pl-7px">
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="title_color" [formControl]="embedForm.controls.title_color"
                label="Title Text" name="Title Text" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="font_color_hover" [formControl]="embedForm.controls.font_color_hover"
                label="Hover Text" name="Hover Text" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="more_button_background" [formControl]="embedForm.controls.more_button_background"
                label="Button Background" name="Button Background" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="hover_text" [formControl]="embedForm.controls.hover_text"
                label="Button Text" name="Button Text" type="text"></gs-input-color-picker>
            </div>
            <!-- <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="body_color" [formControl]="embedForm.controls.body_color"
                label="Author Text" name="Author Text" type="text"></gs-input-color-picker>
            </div> -->
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="user_label_background" [formControl]="embedForm.controls.user_label_background"
                label="User Label Text" name="User Label text" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="guest_label_background" [formControl]="embedForm.controls.guest_label_background"
                label="Guest  Text" name="Label text" type="text"></gs-input-color-picker>
            </div>
            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="tags_highlight" [formControl]="embedForm.controls.tags_highlight"
                label="Tags Highlight" name="Tags Highlight" type="text"></gs-input-color-picker>
            </div>

            <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="author_font" [formControl]="embedForm.controls.author_font"
                label="Author Font" name="Author Font" type="text"></gs-input-color-picker>
            </div>
            <!-- <div class="col-2 extnd_width">
              <gs-input-color-picker formControlName="cta_button_text" [formControl]="embedForm.controls.cta_button_text"
                label="CTA Button Text" name="CTA Button" type="text"></gs-input-color-picker>
            </div> -->
          </div>
          
    
    
          <h6 class="ml-10px">Embed Fonts</h6>
          <div class="row mb-2 pl-19px">
            <div class="adjust_font_container">
              <gs-input-material formControlName="headline_font_size" [formControl]="embedForm.controls.headline_font_size" label="Title Font"
              type="text">
            </gs-input-material>

            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="title_unit" class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            
            </div>
            <div class="adjust_font_container">
              <gs-input-material formControlName="body_font_size" [formControl]="embedForm.controls.body_font_size" label="Body Font"
              type="text">
            </gs-input-material>

            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="body_unit" class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            </div>
            <div class="adjust_font_container">
              <gs-input-material formControlName="author_font_size" [formControl]="embedForm.controls.author_font_size" label="Author Font"
              type="text">
            </gs-input-material>

            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="author_font_unit" class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            </div>
          </div>
          <h6 class="ml-10px">Border</h6>
          <div class="row mb-2 pl-19px">

            <div class="adjust_font_container">
              <gs-input-material formControlName="tile_border" [formControl]="embedForm.controls.tile_border" label="Border"
              type="text">
            </gs-input-material>

            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="tile_border_unit" class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            </div>
            <div class="adjust_font_container">
              <gs-input-material formControlName="tile_border_radius" [formControl]="embedForm.controls.tile_border_radius" label="Border Radius"
              type="text">
            </gs-input-material>

            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="tile_border_radius_unit" class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            
            </div>

          </div>


          <h6 class="ml-10px">More Button</h6>
          <div class="row mb-2 pl-19px">
            <div class="adjust_font_container">
              <gs-input-material formControlName="hover_button" [formControl]="embedForm.controls.hover_button" label="Button Label"
              type="text">
            </gs-input-material>
            </div>
            <div class="adjust_font_container">
              <gs-input-material formControlName="more_button_font_size" [formControl]="embedForm.controls.more_button_font_size" label="Font Size"
              type="text">
            </gs-input-material>
            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="more_button_font_size_unit"  class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            </div>
            <div class="adjust_font_container">
              <gs-input-material formControlName="border_radius" [formControl]="embedForm.controls.border_radius" label="Border Radius"
              type="text">
            </gs-input-material>
            <div class="col iFrame-value">
              <!-- <h6>Px</h6> -->
              <select formControlName="border_unit"  class="box">
                <option value="px">Px</option>
                <option value="rem">rem</option>
                <option value="em">em</option>
              </select>
            </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <span>Embed  Modal</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
      
        <div class="color-wrapper embed-sub-wrapper" *ngIf="!IsScriptCreated">
          <!-- Author -->
          <div class="row mb-2">
            <div class="col-4">
              <gs-input-color-picker formControlName="detail_author_font_color" [formControl]="embedForm.controls.detail_author_font_color"
                label="Author Font Color" name="Author Font Color" type="text">
              </gs-input-color-picker>
            </div>
            <div class="col-8">
              <div class="adjust_font_container_detail">
                <gs-input-material formControlName="detail_author_font_size" [formControl]="embedForm.controls.detail_author_font_size"
                  label="Author Font Size" type="text">
                </gs-input-material>
                <div class="col iFrame-value">
                  <select formControlName="detail_author_font_unit" class="box">
                    <option value="px">Px</option>
                    <option value="rem">rem</option>
                    <option value="em">em</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
      
          <!-- Author Description -->
          <div class="row mb-2">
            <div class="col-4">
              <gs-input-color-picker formControlName="detail_author_description_font_color" [formControl]="embedForm.controls.detail_author_description_font_color"
                label="Author Description Font" name="Author Description Font" type="text">
              </gs-input-color-picker>
            </div>
            <div class="col-8">
              <div class="adjust_font_container_detail">
                <gs-input-material formControlName="detail_author_description_font_size" [formControl]="embedForm.controls.detail_author_description_font_size"
                  label="Author Description Font Size" type="text">
                </gs-input-material>
                <div class="col iFrame-value">
                  <select formControlName="detail_author_description_font_unit" class="box">
                    <option value="px">Px</option>
                    <option value="rem">rem</option>
                    <option value="em">em</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
      
          <!-- Company Name -->
          <div class="row mb-2">
            <div class="col-4">
              <gs-input-color-picker formControlName="detail_company_name_font_color" [formControl]="embedForm.controls.detail_company_name_font_color"
                label="Company Name Font Color" name="Company Name Font Color" type="text">
              </gs-input-color-picker>
            </div>
            <div class="col-8">
              <div class="adjust_font_container_detail">
                <gs-input-material formControlName="detail_company_name_font_size" [formControl]="embedForm.controls.detail_company_name_font_size"
                  label="Company Name Font Size" type="text">
                </gs-input-material>
                <div class="col iFrame-value">
                  <select formControlName="company_name_font_unit" class="box">
                    <option value="px">Px</option>
                    <option value="rem">rem</option>
                    <option value="em">em</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
      
          <!-- Story Title -->
          <div class="row mb-2">
            <div class="col-4">
              <gs-input-color-picker formControlName="detail_story_title_font_color" [formControl]="embedForm.controls.detail_story_title_font_color"
                label="Title Font" name="Title Font" type="text">
              </gs-input-color-picker>
            </div>
            <div class="col-8">
              <div class="adjust_font_container_detail">
                <gs-input-material formControlName="detail_story_title_font_size" [formControl]="embedForm.controls.detail_story_title_font_size"
                  label="Title Font" type="text">
                </gs-input-material>
                <div class="col iFrame-value">
                  <select formControlName="detail_story_title_font_unit" class="box">
                    <option value="px">Px</option>
                    <option value="rem">rem</option>
                    <option value="em">em</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
      
          <!-- Story Prompt -->
          <div class="row mb-2">
            <div class="col-4">
              <gs-input-color-picker formControlName="detail_story_prompt_font_color" [formControl]="embedForm.controls.detail_story_prompt_font_color"
                label="Prompt Font" name="Prompt Font" type="text">
              </gs-input-color-picker>
            </div>
            <div class="col-8">
              <div class="adjust_font_container_detail">
                <gs-input-material formControlName="detail_story_prompt_font_size" [formControl]="embedForm.controls.detail_story_prompt_font_size"
                  label="Prompt Font" type="text">
                </gs-input-material>
                <div class="col iFrame-value">
                  <select formControlName="detail_story_prompt_font_unit" class="box">
                    <option value="px">Px</option>
                    <option value="rem">rem</option>
                    <option value="em">em</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
      
          <!-- Story Body -->
          <div class="row mb-2">
            <div class="col-4">
              <gs-input-color-picker formControlName="detail_story_body_font_color" [formControl]="embedForm.controls.detail_story_body_font_color"
                label="Body Font" name="Body Font" type="text">
              </gs-input-color-picker>
            </div>
            <div class="col-8">
              <div class="adjust_font_container_detail">
                <gs-input-material formControlName="detail_story_body_font_size" [formControl]="embedForm.controls.detail_story_body_font_size"
                  label="Body Font" type="text">
                </gs-input-material>
                <div class="col iFrame-value">
                  <select formControlName="detail_story_body_font_unit" class="box">
                    <option value="px">Px</option>
                    <option value="rem">rem</option>
                    <option value="em">em</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <span>Embed CTA</span></mat-panel-title>
        </mat-expansion-panel-header>
        <div class="color-wrapper embed-sub-wrapper" *ngIf="!IsScriptCreated">
          <div class="row mb-1">
            <div class="col-4">
              <gs-input-color-picker formControlName="cta_button_color" [formControl]="embedForm.controls.cta_button_color"
                label="Button" name="Button" type="text"></gs-input-color-picker>
            </div>
            <div class="col-4">
              <gs-input-color-picker formControlName="cta_button_text_color" [formControl]="embedForm.controls.cta_button_text_color"
                label="Button Text" name="Button Text" type="text"></gs-input-color-picker>
            </div>
            <div class="col-4">
              <gs-input-color-picker formControlName="cta_body_color" [formControl]="embedForm.controls.cta_body_color"
                label="Body Text" name="Body Text" type="text"></gs-input-color-picker>
            </div>
          </div>  
        </div>

        <h6 class="ml-10px">CTA Button</h6>
        <div class="row mb-2 pl-26px">
          <div class="adjust_font_container">
            <gs-input-material formControlName="cta_button_text_font_size" [formControl]="embedForm.controls.cta_button_text_font_size" label="Button Font"
            type="text">
          </gs-input-material>
          <div class="col iFrame-value">
            <!-- <h6>Px</h6> -->
            <select formControlName="cta_button" class="box">
              <option value="px">Px</option>
              <option value="rem">rem</option>
              <option value="em">em</option>
            </select>
          </div>
          </div>
          <div class="adjust_font_container">
            <gs-input-material formControlName="cta_border_radius" [formControl]="embedForm.controls.cta_border_radius" label="Border Radius"
            type="text">
          </gs-input-material>
          <div class="col  iFrame-value">
            <!-- <h6>Px</h6> -->
            <select formControlName="cta_border" class="box">
              <option value="px">Px</option>
              <option value="rem">rem</option>
              <option value="em">em</option>
            </select>
          </div>
          </div>
        </div>

        <h6 class="ml-10px">CTA Message</h6>
        <div class="row mb-2 pl-26px">
          <div class="adjust_font_container">
            <gs-input-material formControlName="cta_message_text_font_size" [formControl]="embedForm.controls.cta_message_text_font_size" label="Font"
            type="text">
          </gs-input-material>
          <div class="col iFrame-value">
            <!-- <h6>Px</h6> -->
            <select formControlName="cta_message_text_font_unit" class="box">
              <option value="px">Px</option>
              <option value="rem">rem</option>
              <option value="em">em</option>
            </select>
          </div>
          </div>
        </div>
      </mat-expansion-panel>


      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> <span>Embed Layout</span></mat-panel-title>
        </mat-expansion-panel-header>
        <div class="radio-wrapper embed-sub-wrapper mb-3 p-3" *ngIf="!IsScriptCreated">
          <div class="row">
            <div class="col-6">
              <h6 class="ml-6px">Embed Layout</h6>
              <div class="row ml-19px">
                <div class="col-4">
                  <div class="custom-control custom-radio">
                    <label class="mb-0">
                      <input type="radio" formControlName="selectRadio" value="tile" class="custom-control-input">
                      <span class="custom-control-label"> Grid</span>
                    </label>
                  </div>
                </div>
                <!-- <div class="col-4">
                  <div class="custom-control custom-radio">
                    <label class="mb-0">
                      <input type="radio" formControlName="selectRadio" value="list" class="custom-control-input">
                      <span class="custom-control-label"> List</span>
                    </label>
                  </div>
                </div> -->
                <div class="col-4">
                  <div class="custom-control custom-radio">
                    <label class="mb-0">
                      <input type="radio" formControlName="selectRadio" value="craousel" class="custom-control-input">
                      <span class="custom-control-label">Carousel</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <h6>Open Story As</h6>
              <div class="row">
                <div class="col-6">
                  <div class="custom-control custom-radio">
                    <label class="mb-0">
                      <input type="radio" formControlName="openToRadio" value="modalWindow" class="custom-control-input">
                      <span class="custom-control-label">Modal Window</span>
                    </label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="custom-control custom-radio">
                    <label class="mb-0">
                      <input type="radio" formControlName="openToRadio" value="newWindow" class="custom-control-input">
                      <span class="custom-control-label">New Window</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-2" *ngIf="embedForm.controls.selectRadio.value == 'craousel'">
            <div class="col-6">
              <gs-input-material formControlName="number_of_items" [formControl]="embedForm.controls.number_of_items" label="Number Of Items Per Slide"
              type="text">
            </gs-input-material>
            </div>
          </div>
        </div>
    
      </mat-expansion-panel>


      
      
    </mat-accordion>



    <div class="embed_tab" *ngIf="!IsScriptCreated">
      <mat-accordion [multi]="false">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> <span>Custom CSS</span></mat-panel-title>
          </mat-expansion-panel-header>
       <div class="row">
        <div class="col">
          <gs-area-material
          label="" name="Add CSS" placeholder="" rows="10"
          cssClass="spacing-lg" formControlName="custom_css" [formControl]="embedForm.controls.custom_css">
      </gs-area-material>
        </div>
       </div>

  
        </mat-expansion-panel>
  
      </mat-accordion>
    </div>

    <div class="lines-wrapper embed-sub-wrapper mb-4 px-3 pb-0 pt-3" *ngIf="!IsScriptCreated">
      <div class="row">
        <!-- <div class="col-6">
          <gs-input-material formControlName="lineCount" [formControl]="embedForm.controls.lineCount"
            label="Lines of Story Content" type="number">
          </gs-input-material>
        </div> -->
        <!-- <div class="col-6">
          <h6>Which Stories</h6>
          <div class="row">
            <div class="col-4">
              <div class="custom-control custom-checkbox">
                <label class="mb-0">
                  <input type="checkbox" formControlName="selectCheckbox" value="public" class="custom-control-input">
                  <span class="custom-control-label">Public</span>
                </label>
              </div>
            </div>
            <div class="col-8">
              <div class="custom-control custom-checkbox">
                <label class="mb-0">
                  <input type="checkbox" value="private" class="custom-control-input" disabled>
                  <span class="custom-control-label">Private (coming soon)</span>
                </label>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <div style="display: flex; justify-content: center;" >
      <div  class="button-wrapper text-center mr-2 mb-4" *ngIf="!IsScriptCreated && feedType != 'POST' ">
        <button style="width:8rem" [disabled]="disableSavButton" (click)="getScript(true)" type="button" class="btn btn-pink min-width">
          <i
          *ngIf="isUpdating" class="fas fa-spinner fa-pulse"></i>
        {{buttonlabel}}
        </button>
      </div>
  
      <div class="button-wrapper text-center" *ngIf="!IsScriptCreated">
        <button (click)="getScript(false)" type="button" class="btn btn-pink min-width">
          Get Script
        </button>
      </div>
    </div>



    <div class="code-wrapper embed-form-disabled" *ngIf="IsScriptCreated && activeTab == 'embedCode'">
      <h6>Place the below code inside your <span>&lt;body&gt;</span> tag.</h6>
      <div class="form-label-group form-group-copy nolabel">
        <gs-input-clipboard name="bodyCode" placeholder="Body Code" formControlName="bodyCode"
          [formControl]="embedForm.controls.bodyCode"></gs-input-clipboard>
      </div>
      <h6>Place the below code just before <span>&lt;/body&gt;</span> tag.</h6>
      <div class="form-label-group form-group-copy nolabel">
        <gs-textarea-clipboard rows="6" name="headerCode" placeholder="Header Code" formControlName="headerCode"
          [formControl]="embedForm.controls.headerCode"></gs-textarea-clipboard>
      </div>
      <h6>You can use these classes to override the CSS under <span>&lt;style&gt;</span> tag.</h6>
      <div class="form-label-group form-group-copy nolabel">
        <gs-textarea-clipboard rows="8" name="styleCode" placeholder="Style" formControlName="styleCode"
          [formControl]="embedForm.controls.styleCode"></gs-textarea-clipboard>
      </div>
    </div>
  </div>




  <div class="color-wrapper embed-sub-wrapper mb-4 px-3 pb-0 pt-3" *ngIf="activeTab == 'iframe'"
    [formGroup]="iFrameForm">
    <div class="row mt-0">
      <div class="col-3 iFrame-value px-3">
        <h6>Which Page</h6>
      </div>
      <div class="col-2">
        <div class="custom-control custom-radio">
          <label class="mb-0">
            <input type="radio" formControlName="selectCheckbox" value="public" class="custom-control-input">
            <span class="custom-control-label">Public</span>
          </label>
        </div>
      </div>
      <div class="col-2">
        <div class="custom-control custom-radio">
          <label class="mb-0">
            <input type="radio" formControlName="selectCheckbox" value="private" class="custom-control-input">
            <span class="custom-control-label">Private</span>
          </label>
        </div>
      </div>
    </div>
 



    <div class="row mt-3">
      <div class="col-3 iFrame-value px-3">
        <h6>Display Page Header</h6>
      </div>
      <div class="col-4">
        <div class="custom-control custom-checkbox">
          <label class="mb-0">
            <input type="checkbox" formControlName="showHeader" class="custom-control-input">
            <span class="custom-control-label"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-3 iFrame-value px-3">
        <h6>Display Tag Summary</h6>
      </div>
      <div class="col-4">
        <div class="custom-control custom-checkbox">
          <label class="mb-0">
            <input type="checkbox" formControlName="showtagheader" class="custom-control-input">
            <span class="custom-control-label"></span>
          </label>
        </div>
      </div>
    </div>
    
    <div class="row mt-3" *ngIf="initialState.sendData.from == 'company'">
      <div class="col-3 iFrame-value px-3">
        <h6>Display Nav Items</h6>
      </div>
      <div class="col-2 titleDispaly">
        <div class="custom-control custom-checkbox" [ngClass]="{'isClickable':!iFrameForm.value.isCampaigns && !iFrameForm.value.isStories}">
          <label class="mb-0 ml-0">
            <input type="checkbox"   formControlName="isSpotlight" class="custom-control-input">
            <span class="custom-control-label"></span>
          </label>
        </div>
       <span class="mt-1">Spotlights</span> 
      </div>
      <div class="col-2 titleDispaly">
        <div class="custom-control custom-checkbox" [ngClass]="{'isClickable':!iFrameForm.value.isSpotlight && !iFrameForm.value.isStories}">
          <label class="mb-0 ml-3">
            <input type="checkbox" [disabled]="!iFrameForm.value.isSpotlight && !iFrameForm.value.isStories" formControlName="isCampaigns" class="custom-control-input">
            <span class="custom-control-label"></span>
          </label>
        </div>
         <span class="mt-1" >Campaigns</span> 

      </div>
      <div class="col-2 titleDispaly">
        <div class="custom-control custom-checkbox" [ngClass]="{'isClickable':!iFrameForm.value.isSpotlight && !iFrameForm.value.isCampaigns}">
          <label class="mb-0 ml-3" >
            <input type="checkbox"  formControlName="isStories" class="custom-control-input">
            <span class="custom-control-label"></span>
          </label>
        </div>
        <span class="mt-1" >All</span> 
      </div>
    </div>

    <div class="row mt-3 mb-2" *ngIf="iFrameForm.controls.selectCheckbox.value == 'public'">
    <div class="col-3 iFrame-value px-3">
      <h6>Display Public Footer</h6>
    </div>
      <div class="col-md-2">
        <div>
          <label class="switch mr-1">
            <input type="checkbox" formControlName="isFooter"><span class="slider"></span>
          </label>
          <div class="w-50-p d-inline-block">
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3 mb-2">
      <div class="col-3 iFrame-value px-3">
        <h6>Display Border</h6>
      </div>
      <div class="col-4">
        <div class="custom-control custom-checkbox">
          <label class="mb-0">
            <input type="checkbox" formControlName="selectRadio" class="custom-control-input">
            <span class="custom-control-label"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-3 iFrame-value px-3">
        <h6>iFrame Height</h6>
      </div>
      <div class="col-lg-2">
        <gs-input-material formControlName="height" [formControl]="iFrameForm.controls.height" label="height"
          type="number">
        </gs-input-material>
      </div>
      <div class="col iFrame-value">
        <!-- <h6>Px</h6> -->
        <select formControlName="heightList" class="box">
          <option value="px">Px</option>
          <option value="%">%</option>
          <option value="rem">rem</option>
          <option value="vh">vh</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 iFrame-value px-3">
        <h6>iFrame Width</h6>
      </div>
      <div class="col-lg-2">
        <gs-input-material formControlName="width" [formControl]="iFrameForm.controls.width" label="Width"
          type="number">
        </gs-input-material>
      </div>
      <div class="col iFrame-value">
        <select formControlName="widthList" class="box">
          <option value="px">Px</option>
          <option value="%">%</option>
          <option value="rem">rem</option>
          <option value="vh">vh</option>
        </select>
      </div>
    </div>

    <div class="code-wrapper embed-form-disabled mb-4">
      <h6 class="mt-4 mb-3">Place the below code inside your <span>&lt;body&gt;</span> tag. {{updatedIframeCode}}</h6>
      <div class="form-label-group form-group-copy nolabel">
        <gs-input-clipboard name="bodyCode" placeholder="Body Code" formControlName="bodyCode"
          [formControl]="iFrameForm.controls.bodyCode"></gs-input-clipboard>
      </div>
    </div>
    <h6 >Add code below for responsive embed</h6>
    <div class="form-label-group form-group-copy nolabel" [formGroup]="iFrameForm">
        <gs-textarea-clipboard rows="8" name="styledbodyCode" placeholder="Style" formControlName="styledbodyCode"
          [formControl]="iFrameForm.controls.styledbodyCode"></gs-textarea-clipboard>
      </div>
    
  </div>

  <div class="color-wrapper embed-sub-wrapper mb-4 px-3 pb-0 pt-3" *ngIf="activeTab == 'RSS'"
  [formGroup]="rssForm">
  <div class="code-wrapper embed-form-disabled">
    <h6 class="mt-4 mb-3">COPY RSS LINK (INTERNAL AND PUBLIC) &nbsp; <span class="svgForRss"><svg role="img">
      <use xlink:href="#icon-rss"></use>
    </svg></span></h6>
    <div class="form-label-group form-group-copy nolabel">
      <gs-input-clipboard name="LINK" placeholder="LINK" formControlName="value"
        [formControl]="rssForm.controls.value"></gs-input-clipboard>
    </div>
  </div>
  <div class="code-wrapper embed-form-disabled">
    <h6 class="mt-4 mb-3">COPY RSS LINK (PUBLIC ONLY) &nbsp; <span class="svgForRss"><svg role="img">
      <use xlink:href="#icon-rss"></use>
    </svg></span></h6>
    <div class="form-label-group form-group-copy nolabel">
      <gs-input-clipboard name="LINK" placeholder="LINK" [disabled]="true" formControlName="publicValue"
        [formControl]="rssForm.controls.publicValue"></gs-input-clipboard>
    </div>
  </div>
</div>

<div class="color-wrapper embed-sub-wrapper mb-4 px-3 pb-0 pt-3" [formGroup]="embedButtonForm"  *ngIf="activeTab == 'embedButton'">
  <div class="embed-btn" *ngIf="!IsScriptCreated">
    <div class="row mb-4">
      <div class="col-3"><h6>Open Story Builder In:</h6></div>
      <div class="col-4" style="padding-left: 2rem;">
        <div class="custom-control custom-radio">
          <label class="mb-0">
            <input type="radio" formControlName="selectRadio" value="_self" class="custom-control-input">
            <span class="custom-control-label">Current Tab</span>
          </label>
        </div>
      </div>
      <div class="col-4" style="padding-left: 0rem;">              
        <div class="custom-control custom-radio">
        <label class="mb-0">
          <input type="radio" formControlName="selectRadio" value="_blank" class="custom-control-input">
          <span class="custom-control-label">Popup Window</span>
        </label>
      </div>
    </div>
    </div>
    <div class="row">
      <div class="col-3">
        <!--<h6>Button Text</h6>-->
        <gs-input-material type="text" label="Button Label" formControlName="buttonText" [formControl]="embedButtonForm.controls.buttonText" class="btn-text">
        </gs-input-material>
      </div>
      <div class="col-3">
        <gs-input-color-picker formControlName="backgroundColor" [formControl]="embedButtonForm.controls.backgroundColor"
        label="Button Background" name="BackgroundColor" type="text"></gs-input-color-picker>
        <!-- <gs-input-color-picker  formControlName="backgroundColor" [formControl]="embedButtonForm.controls.backgroundColor" label="Background" name="BackgroundColor" type="text"></gs-input-color-picker> -->
    </div>
    <div class="col-3">
      <!-- <gs-input-color-picker  formControlName="textColor" [formControl]="embedButtonForm.controls.textColor" label="Text Color" name="Textcolor" type="text"></gs-input-color-picker> -->
      <gs-input-color-picker formControlName="textColor" [formControl]="embedButtonForm.controls.textColor"
      label="Button Text" name="TextColor" type="text"></gs-input-color-picker>
    </div>
    </div>
    
    <div class="row mt-0">
      <div class="col-3">
        <gs-input-material formControlName="fontsize" [formControl]="embedButtonForm.controls.fontsize" label="Font Size (px)"
          type="number">
        </gs-input-material>
      </div>
      <div class="col-3 form-label-group embed_testimonial">
        <input type="number" formControlName="width"  class="form-control">
        <label>Button Width (px)</label>     
       </div>
      <div class="col-3 form-label-group embed_testimonial">
        <input type="number" formControlName="height"  class="form-control">
        <label>Button Height (px)</label>     
       </div>
    </div>
    <div class="row">
      <div class="col-3">
        <gs-input-material formControlName="paddingbottom" [formControl]="embedButtonForm.controls.paddingbottom" label="Padding bottom (px)"
        type="text">
      </gs-input-material>
      </div>
      <div class="col-3">
        <gs-input-material formControlName="paddingleft" [formControl]="embedButtonForm.controls.paddingleft" label="Padding left (px)"
        type="text">
      </gs-input-material>
      </div>
      <div class="col-3">
        <gs-input-material formControlName="paddingright" [formControl]="embedButtonForm.controls.paddingright" label="Padding right (px)"
        type="text">
      </gs-input-material>
      </div>
      <div class="col-3">
        <gs-input-material formControlName="paddingtop" [formControl]="embedButtonForm.controls.paddingtop" label="Padding top (px)"
        type="text">
      </gs-input-material>
      </div>
    </div>
    <div class="embed_tab">
      <mat-accordion [multi]="false">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> <span>Custom CSS</span></mat-panel-title>
          </mat-expansion-panel-header>
       <div class="row">
        <div class="col">
          <gs-area-material
          label="" name="Add CSS" placeholder="" rows="10"
          cssClass="spacing-lg" formControlName="customStyleCode" [formControl]="embedButtonForm.controls.customStyleCode">
      </gs-area-material>
        </div>
       </div>

  
        </mat-expansion-panel>
  
      </mat-accordion>
    </div>


  </div>


  <div class="option-wrapper embed-sub-wrapper mb-4 mt-4 p-3 text-center" *ngIf="!IsScriptCreated">
    <div class="row">
      <div class="col-12">
        <div [id]="initialState.sendData.paraentDiv">
          <button type="button" id="embed_btn" target="_self" href="javascript:void(0);" >
            {{embedButtonForm.controls.buttonText.value}}
          </button>
        </div>

      </div>
    </div>
  </div>

  <div class="button-wrapper text-center" *ngIf="!IsScriptCreated">
    <button (click)="getEmbedButtonScript()" [disabled]="embedButtonForm.invalid" type="button" class="btn btn-pink min-width">
      Get Script
    </button>
  </div>

  <div class="code-wrapper embed-form-disabled" *ngIf="IsScriptCreated">
    <h6>Place the below code inside your <span>&lt;body&gt;</span> tag.</h6>
    <div class="form-label-group form-group-copy nolabel">
      <gs-input-clipboard name="bodyCode" placeholder="Body Code" formControlName="bodyCode"
        [formControl]="embedButtonForm.controls.bodyCode"></gs-input-clipboard>
    </div>
    <h6>Place the below code just before <span>&lt;/body&gt;</span> tag.</h6>
    <div class="form-label-group form-group-copy nolabel">
      <gs-textarea-clipboard rows="6" name="headerCode" placeholder="Header Code" formControlName="headerCode"
        [formControl]="embedButtonForm.controls.headerCode"></gs-textarea-clipboard>
    </div>

  </div>
</div>

<div class="color-wrapper embed-sub-wrapper mb-4 px-3 pb-0 pt-3" *ngIf="activeTab == 'dataUrl'" [formGroup]="rssForm">
  <div class="code-wrapper embed-form-disabled">
    <h6 class="mt-4 mb-3">COPY DATA URL</h6>
    <div class="form-label-group form-group-copy nolabel">
      <gs-input-clipboard 
        name="dataUrl" 
        placeholder="Data URL" 
        formControlName="dataUrlValue"
        [formControl]="rssForm.controls.dataUrlValue">
      </gs-input-clipboard>
    </div>
  </div>
</div>
</div>